import { h } from 'preact'
import styles from './index.module.css'

type PullQuoteProps = {
  quoteText: string
  quoteSource: string
}

export function PullQuote(props: PullQuoteProps) {
  return (
    <div className={styles.pullQuote} aria-hidden>
      <blockquote>
        <div className={styles.quoteText}>
          <i />
          <p>{props.quoteText}</p>
        </div>
        <small className={styles.quoteSource}>
          <i />
          <p>{props.quoteSource}</p>
        </small>
      </blockquote>
    </div>
  )
}
